export const parameterize = (string: string) => string.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-')

export const capitalizeWords = (string: string) => string.toLowerCase()
  .split(/\s+/)
  .map(s => s.charAt(0).toUpperCase() + s.substring(1))
  .join(' ')

